// Copyright (c) 2016 Deere & Company

import Component from '@deere/cps-it.warranty-model-factory/lib/component';
import t from 'tcomb';

const Components = t.list(Component, 'Components');

export const getDefaultState = () => new Components([]);

export default Components;



// WEBPACK FOOTER //
// ./src/product/details/state/components.js